export default "__VITE_ASSET__U12BTAmL__"